export default [
    {
        path: '/certificado',
        name: 'certificado',
        component: () => import(/* webpackChunkName: "home" */ './Certificado')
    }
]
